import { ICatalogueState } from '@signature-it/ngx-catalogue/store/interfaces';
import { createFeatureSelector } from "@ngrx/store";

// DO NOT MOVE IT - ITS FOR COMPILATION
import {PriceDTO, StockDTO, GroupUserLinksFields, Group, ProductFullSolrDTO} from '@signature-it/ngx-catalogue/models';

export const getCatalogueState = createFeatureSelector<ICatalogueState>('catalogue');
export const getCataloguePriceList = (store: ICatalogueState) => getCatalogueState(store).priceList;
export const getLoadingPriceList = (store: ICatalogueState) => getCatalogueState(store).loadingPriceList;
export const getLoadingUserLinks = (store: ICatalogueState) => getCatalogueState(store).loadingUserLinks;
export const getCatalogueStockList = (store: ICatalogueState) => getCatalogueState(store).stockList;
export const getGroupUserLinksFields = (store: ICatalogueState) => getCatalogueState(store).groupUserLinksFields;
export const getGroupsTree = (store: ICatalogueState) => getCatalogueState(store).groupsTree;
export const loadingGroupsTree = (store: ICatalogueState) => getCatalogueState(store).loadingGroupsTree;
export const getCurrentGroup = (store: ICatalogueState) => getCatalogueState(store).currentGroup;
export const getProductSolrDoc = (store: ICatalogueState) => getCatalogueState(store).productSolrDoc;
export const loadingProductSolrDoc = (store: ICatalogueState) => getCatalogueState(store).loadingProductSolrDoc;
export const getFavoritesList = store => getCatalogueState(store).favoritesList;
export const getFavoritesIds = store => getCatalogueState(store).favoritesIds;
export const loadingFavoritesList = store => getCatalogueState(store).loadingFavoritesList;
export const updatedFavoritesSuccess = store => getCatalogueState(store).updatedFavoritesSuccess;
export const removeFavoritesSuccess = store => getCatalogueState(store).removeFavoritesSuccess;
